import { CompanyType, DashboardPlatformAdminRevenueDistributionItemInfoFragment } from 'src/api';

import { VerificationRequestGroup } from './types';

const mapping: Record<CompanyType, VerificationRequestGroup> = {
  [CompanyType.Peo]: VerificationRequestGroup.peo,
  [CompanyType.Employer]: VerificationRequestGroup.employers,
  [CompanyType.PeoPayrollProvider]: VerificationRequestGroup.peoPayrollProvider,
};

export const prepareDataset = (
  revenueDistributions: DashboardPlatformAdminRevenueDistributionItemInfoFragment[],
) =>
  revenueDistributions.map(distribution => ({ ...distribution, type: mapping[distribution.type] }));
